import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IActiveServiceEvent, IGetServiceEventState } from '../../actions/types/services/GetAllServiceEventTypes';

/**
 * Initial Serivce Event state in store
 */
const initialState: IGetServiceEventState = {
  isLoading: false,
  serviceEventErrorMessage: '',
  activeServiceEvent: []
};

const fetchEgressServiceEventSlice = createSlice({
  name: 'fetchServiceEvent',
  initialState,
  reducers: {
    fetchEgressServiceEventStarted: (state) => {
      state.isLoading = true;
    },

    fetchEgressServiceEventSuccess: (state, action: PayloadAction<IActiveServiceEvent[]>) => {
      state.isLoading = false;
      state.activeServiceEvent = action.payload;
      state.serviceEventErrorMessage = '';
    },

    fetchEgressServiceEventFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.activeServiceEvent = initialState.activeServiceEvent;
      state.serviceEventErrorMessage = action.payload;
    },

    clearEgressServiceEventDetails: (state) => {
      state.isLoading = false;
      state.activeServiceEvent = initialState.activeServiceEvent;
      state.serviceEventErrorMessage = '';
    }
  }
});
export const {
  fetchEgressServiceEventStarted,
  fetchEgressServiceEventSuccess,
  fetchEgressServiceEventFail,
  clearEgressServiceEventDetails
} = fetchEgressServiceEventSlice.actions;
export default fetchEgressServiceEventSlice.reducer;
